<template>
  <!-- popover page contents -->
  <div class="popup popup-enterprise">
    <header class="bar bar-nav close-popup">
      <router-link class="button button-link button-nav pull-right" :to="{}">
        <span class="icon icon-down"></span>
      </router-link>
      <h1 class='title'>单位搜索</h1>
    </header>
    <div class="bar bar-header-secondary">
      <div class="searchbar">
        <a @click="valueConvey2" class="searchbar-cancel close-popup">确认</a>
        <div class="search-input">
          <label class="icon icon-search" for="searchEnterprise"></label>
          <input type="search" v-model.trim="query" id="searchEnterprise" placeholder='单位名称'/>
        </div>
      </div>
    </div>
    <div style="height: 68px;"></div>
    <div class="list-block">
      <ul id="list">
        <li @click="valueConvey(index)" class="item-content" v-for="(company, index) in filteredData">
            <div class="item-inner close-popup">
            <div id="resultsEnterprise" class="item-title">
              {{company.enterpriseName}}
            </div>
            <div class="item-after">
              <span v-model="enterpriseNo" class="badge">{{company.enterpriseNo}}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  import EMKT from '../emkt'
  import $ from 'jquery'

  export default {
    mounted () {
      this.removeChoose()
      let enterprise = $('.popup-enterprise')
      enterprise.on('open', function () {
        EMKT.setStoreItem('enterprisePopupFlag', true)
        console.log('popup is opening')
      })
      enterprise.on('closed', function () {
        EMKT.setStoreItem('enterprisePopupFlag', false)
        console.log('popup closed')
      })
    },
    created () {
      // 组件创建完后获取数据，
      // 此时 data 已经被 observed 了
      this.fetchData()
    },
    data () {
      return {
        query: '',
        data: {},
        filteredData: {},
        enterpriseNo: ''
      }
    },
    watch: {
      // listening to input
      'query': function (query) {
        console.log('in query')
        let _this = this
        _this.initialize()
        let data = _this.data
        let filteredData = _this.filteredData
        for (let i = 0; i < data.length; i++) {
          if (data[i]['enterpriseName'].match(query.toLowerCase())) {
            let item = {
              'enterpriseName': data[i].enterpriseName,
              'enterpriseNo': data[i].enterpriseNo,
              'locationName': data[i].locationName,
              'regionName': data[i].regionName
            }
            filteredData.push(item)
            if (filteredData.length > 19) {
              break
            }
          }
        }
      }
    },
    methods: {
      ...mapMutations([
        'ENTERPRISE_INFO_UPDATE', 'UPDATE_DEPARTMENT_INFO'
      ]),
      fetchData () {
        // fetching data from localstorage
        this.data = EMKT.getLocalStorage('EmktFirstLevelEnterpriseList')
      },
      initialize () {
        this.filteredData = []
      },
      removeChoose () {
        this.ENTERPRISE_INFO_UPDATE('')
      },
      valueConvey (index) {
        let _this = this
        var choice = {
          'enterpriseName': _this.filteredData[index].enterpriseName,
          'enterpriseNo': _this.filteredData[index].enterpriseNo,
          'locationName': _this.filteredData[index].locationName,
          'regionName': _this.filteredData[index].regionName
        }
        _this.ENTERPRISE_INFO_UPDATE(choice)
        _this.UPDATE_DEPARTMENT_INFO({})
        _this.query = ''
      },
      valueConvey2 () {
        let _this = this
        var choice = {
          'enterpriseName': _this.query,
          'enterpriseNo': ''
        }
        _this.ENTERPRISE_INFO_UPDATE(choice)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// EnterpriseBox.vue?4602a43f